import { RecordBase } from '../../providers/request/record-base.model';
import { ProjectItemType } from './project-item-type.enum';
export class ProjectSectionUnit extends RecordBase {
  projectId?: number;
  sectionId?: number;
  sectionItemId?: number;
  sectionItemType?: ProjectItemType;
  sectionItemIndex?: number;
  codeSpan?: number;
  code?: string;
  codeName?: string;
  name?: string;
  sectionSectionItemId?: number;
  sectionSpan?: number;
  sectionCode?: string;
  sectionName?: string;
  segmentSectionItemId?: number;
  segmentSpan?: number;
  segmentCode?: string;
  segmentName?: string;
  partitionSectionItemId?: number;
  partitionSpan?: number;
  partitionCode?: string;
  partitionName?: string;
  isLJ?: boolean;
  fullCode?: string;
  fullName?: string;
  fxFullName?: string;
  projectTypeCodeSpan?: number;
  projectTypeCode?: string;
  projectTypeCodeChange?: boolean;
  projectTypeName?: string;
  highwayLevel?: string;
  mark?: string;
  constructionOrgName?: string;
  mileage?: string;
  appProcedure?: boolean;
  appProcedureMileage?: string;
  dwMileage?: string;
  data1?: number;
  data2?: number;
  data3?: number;
  dwSectionItemId?: number;
  dwSpan?: number;
  dwCode?: string;
  dwName?: string;
  subDwSectionItemId?: number;
  subDwSpan?: number;
  subDwCode?: string;
  subDwName?: string;
  fbSectionItemId?: number;
  fbSpan?: number;
  fbCode?: string;
  fbName?: string;
  fxAlias?: string;
  subFbSectionItemId?: number;
  subFbSpan?: number;
  subFbCode?: string;
  subFbName?: string;
  fxSectionItemId?: number;
  fxSpan?: number;
  fxCode?: string;
  fxName?: string;
  sub1FxSectionItemId?: number;
  sub1FxSpan?: number;
  sub1FxCode?: string;
  sub1FxName?: string;
  sub2FxSectionItemId?: number;
  sub2FxSpan?: number;
  sub2FxCode?: string;
  sub2FxName?: string;
  sortOrder?: number;
  inRecycleBin?: boolean;
  comment?: string;
  // 前端自用
  layerCode?: string;
  level?: number;
  layerSpan?: number;
  fileCount?: number;
  mcode?: string;
}
